<div kendoDialogContainer></div>

<router-outlet></router-outlet>


